import {
  OrderByIdViewQuery$data,
  OrdersViewQuery$data,
} from '@bts-web/data-layer/server';

export enum TradePriceType {
  MARKET = 'market',
  STOP = 'stop',
}

export type OrdersListItemType = NonNullable<
  NonNullable<NonNullable<OrdersViewQuery$data['orders']>['edges']>[number]
>['node'];

export type OrderForPreview = NonNullable<
  NonNullable<OrdersViewQuery$data['orders']>['edges']
>[1];

export type OrderForSummary = OrderByIdViewQuery$data['order'];

export enum OrderOperation {
  BUY = 'BUY',
  SELL = 'SELL',
}

type OrderStatusMap<T> = Record<OrderStatus, T> & { [customStatus: string]: T };

export enum OrderStatus {
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
  FINISHED = 'FINISHED',
  ACCEPTED = 'ACCEPTED',
  CREATED = 'CREATED',
}

export const OrderStatusLabels: OrderStatusMap<string> = {
  CANCELED: 'CANCELED',
  CREATED: 'CREATED',
  FAILED: 'FAILED',
  FINISHED: 'FINISHED',
  ACCEPTED: 'ACCEPTED',
};
